import React, { useState } from "react";
import { Notification, Collapsible } from 'grommet';

const BannerNotification = () => {

  const [showNotification, setShowNotification] = useState(true);

  return (
    <Collapsible open={showNotification}>
      <Notification
        status="normal"
        title="Welcome!"
        margin={{ top: '5px' }}
        onClose={() => setShowNotification(false)}
        actions={[
          {
            href: 'https://www.007.com/',
            label: 'More info',
          },
        ]}
        message="We hope you enjoy your new HPE Sales Cockpit. "
        global
      />
    </Collapsible>
   );
};

export { BannerNotification as Notification };